/*
 * Wolf Sports — Carrinho lateral
 * Independente do theme.js: usa a Cart AJAX API + Section Rendering API.
 */
(function () {
  'use strict';
  // Nota: window.WolfCartDrawer seria o próprio elemento (id), por isso usamos outra flag.
  if (window.__wolfCartInit) return;
  window.__wolfCartInit = true;

  var SECTION = 'wolf-cart-drawer';
  var TIMER_KEY = 'wcd_timer_end';
  var root = document.getElementById('WolfCartDrawer');
  if (!root) return;

  var panel = root.querySelector('.wcd__panel');
  var toastEl = root.querySelector('.wcd__toast');
  var rootUrl = (window.routes && window.routes.rootUrl) || '/';
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';

  var isOpen = false;
  var lastFocus = null;
  var queue = Promise.resolve();
  var pending = 0;
  var toastTimer = null;

  /* ---------- utilidades ---------- */
  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function sectionEl() { return document.getElementById('shopify-section-' + SECTION); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); } catch (e) {}
  }

  function setBusy(on) {
    pending += on ? 1 : -1;
    if (pending < 0) pending = 0;
    root.classList.toggle('is-busy', pending > 0);
  }

  // Executa pedidos ao carrinho em série (evita condições de corrida).
  function enqueue(task) {
    var run = function () {
      setBusy(true);
      return Promise.resolve().then(task).catch(function (err) {
        toast((err && err.message) || 'Ocorreu um erro. Tenta novamente.', 'error');
      }).then(function () { setBusy(false); });
    };
    queue = queue.then(run, run);
    return queue;
  }

  function parseJSON(res) {
    return res.text().then(function (txt) {
      var data = {};
      try { data = txt ? JSON.parse(txt) : {}; } catch (e) { data = {}; }
      if (!res.ok) {
        var msg = data.description || data.message || 'Não foi possível atualizar o carrinho.';
        if (typeof msg !== 'string') msg = 'Não foi possível atualizar o carrinho.';
        var err = new Error(msg);
        err.data = data;
        throw err;
      }
      return data;
    });
  }

  function cartPost(path, data) {
    data = data || {};
    data.sections = SECTION;
    return fetch(rootUrl + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(parseJSON);
  }

  function getCart() {
    return fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(parseJSON);
  }

  function fetchSection() {
    return fetch(rootUrl + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(parseJSON)
      .then(function (json) { render(json[SECTION]); });
  }

  /* ---------- renderização ---------- */
  function render(html) {
    var cur = sectionEl();
    if (!html || !cur) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + SECTION);
    if (!fresh) return;

    var body = qs('.wcd-body', cur);
    var bodyScroll = body ? body.scrollTop : 0;
    var track = qs('[data-wcd-recs-track]', cur);
    var trackScroll = track ? track.scrollLeft : 0;
    var coupon = qs('[data-wcd-coupon]', cur);
    var couponOpen = coupon ? coupon.open : false;
    var couponValue = coupon ? (qs('.wcd-coupon__input', coupon) || {}).value : '';

    cur.innerHTML = fresh.innerHTML;

    body = qs('.wcd-body', cur);
    if (body) body.scrollTop = bodyScroll;
    track = qs('[data-wcd-recs-track]', cur);
    if (track) track.scrollLeft = trackScroll;
    coupon = qs('[data-wcd-coupon]', cur);
    if (coupon) {
      if (couponOpen) coupon.open = true;
      var input = qs('.wcd-coupon__input', coupon);
      if (input && couponValue) input.value = couponValue;
    }
    afterRender();
  }

  function itemCount() {
    var inner = qs('.wcd-inner');
    return inner ? parseInt(inner.getAttribute('data-count'), 10) || 0 : 0;
  }

  function afterRender() {
    var count = itemCount();
    qsa('.header__cart-count', document).forEach(function (el) { el.textContent = count; });
    if (window.theme) window.theme.cartCount = count;
    if (count === 0) lsDel(TIMER_KEY);
    tickTimer();
    updateRecsNav();
    markSizes();
  }

  /* ---------- abrir / fechar ---------- */
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wcd-lock');
    tickTimer();
    updateRecsNav();
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 60);
    emit('wolf:cart:open');
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wcd-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    emit('wolf:cart:close');
  }

  function refreshAndOpen() {
    open();
    enqueue(fetchSection);
  }

  /* ---------- toast ---------- */
  function toast(msg, type) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.className = 'wcd__toast is-show' + (type === 'error' ? ' is-error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.className = 'wcd__toast'; }, 3200);
  }

  /* ---------- contador ---------- */
  function tickTimer() {
    var box = qs('[data-wcd-timer]');
    if (!box || itemCount() === 0) return;
    var minutes = parseInt(box.getAttribute('data-minutes'), 10) || 15;
    var total = minutes * 60000;
    var now = Date.now();
    var end = parseInt(lsGet(TIMER_KEY), 10) || 0;
    // Novo contador na primeira vez ou numa nova visita (expirado há mais de 30 min).
    if (!end || end + 30 * 60000 < now) {
      end = now + total;
      lsSet(TIMER_KEY, String(end));
    }
    var left = Math.max(0, end - now);
    var clock = qs('[data-wcd-timer-clock]', box);
    var label = qs('[data-wcd-timer-label]', box);
    var bar = qs('[data-wcd-timer-progress]', box);
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    if (clock) clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    if (bar) bar.style.width = (Math.min(1, left / total) * 100).toFixed(2) + '%';
    box.classList.toggle('is-urgent', left > 0 && left <= 60000);
    var expired = left === 0;
    if (expired !== box.classList.contains('is-expired')) {
      box.classList.toggle('is-expired', expired);
      if (label) {
        if (!label.getAttribute('data-default')) label.setAttribute('data-default', label.textContent);
        label.textContent = expired ? (label.getAttribute('data-expired') || label.textContent) : label.getAttribute('data-default');
      }
    }
  }
  setInterval(function () { if (isOpen) tickTimer(); }, 1000);

  /* ---------- recomendações ---------- */
  function updateRecsNav() {
    var track = qs('[data-wcd-recs-track]');
    if (!track) return;
    var prev = qs('[data-wcd-recs-prev]');
    var next = qs('[data-wcd-recs-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function recData(card) {
    var el = qs('[data-wcd-variants]', card);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function markSizes() {
    qsa('[data-wcd-rec]').forEach(function (card) {
      var data = recData(card);
      if (!data || data.si < 0) return;
      qsa('[data-wcd-size]', card).forEach(function (btn) {
        var val = btn.getAttribute('data-wcd-size');
        var ok = data.v.some(function (v) { return v.a && v.o[data.si] === val; });
        btn.disabled = !ok;
      });
    });
  }

  function pickVariant(data, size) {
    var defaults = data.v[0] ? data.v[0].o : [];
    var list = data.v.filter(function (v) { return v.a && (data.si < 0 || v.o[data.si] === size); });
    var exact = list.filter(function (v) {
      return v.o.every(function (val, j) { return j === data.si || val === defaults[j]; });
    })[0];
    return exact || list[0] || null;
  }

  function addVariant(id) {
    return enqueue(function () {
      return cartPost('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function (json) {
        render(json.sections && json.sections[SECTION]);
        var body = qs('.wcd-body');
        if (body) body.scrollTo ? body.scrollTo({ top: 0, behavior: 'smooth' }) : (body.scrollTop = 0);
        toast('Adicionado ao carrinho');
        emit('wolf:cart:added', { id: id, quantity: 1 });
      });
    });
  }

  /* ---------- quantidades ---------- */
  function changeLine(line, qty) {
    qty = Math.max(0, parseInt(qty, 10) || 0);
    var row = qs('.wcd-item[data-line="' + line + '"]');
    if (row) row.classList.add('is-updating');
    return enqueue(function () {
      return cartPost('cart/change.js', { line: parseInt(line, 10), quantity: qty }).then(function (json) {
        render(json.sections && json.sections[SECTION]);
        emit('wolf:cart:changed', { line: line, quantity: qty });
      }, function (err) {
        if (row) row.classList.remove('is-updating');
        return fetchSection().then(function () { throw err; });
      });
    });
  }

  /* ---------- cupões ---------- */
  function couponMsg(text, type) {
    var el = qs('[data-wcd-coupon-msg]');
    var box = qs('[data-wcd-coupon]');
    if (box) box.open = true;
    if (!el) return;
    el.textContent = text || '';
    el.className = 'wcd-coupon__msg' + (text ? ' is-show' : '') + (type === 'error' ? ' is-error' : ' is-ok');
  }

  function applicableCodes(cart, except) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; })
      .filter(function (c) { return !except || c.toLowerCase() !== except.toLowerCase(); });
  }

  function applyCode(code) {
    code = (code || '').trim();
    if (!code) { couponMsg('Insere um código de desconto.', 'error'); return; }
    var btn = qs('.wcd-coupon__apply');
    if (btn) btn.classList.add('is-loading');
    enqueue(function () {
      return getCart().then(function (cart) {
        var codes = applicableCodes(cart, code).concat([code]);
        return cartPost('cart/update.js', { discount: codes.join(',') });
      }).then(function (json) {
        var found = (json.discount_codes || []).filter(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        })[0];
        if (found && found.applicable) {
          render(json.sections && json.sections[SECTION]);
          var input = qs('.wcd-coupon__input');
          if (input) input.value = '';
          couponMsg('Código ' + found.code.toUpperCase() + ' aplicado com sucesso.', 'ok');
          emit('wolf:cart:discount', { code: found.code });
          return;
        }
        // Código inválido ou não aplicável: retira-o para não ficar pendurado no carrinho.
        return cartPost('cart/update.js', { discount: applicableCodes(json, code).join(',') }).then(function (j2) {
          render(j2.sections && j2.sections[SECTION]);
          couponMsg('Este código não é válido ou não se aplica aos produtos do carrinho.', 'error');
        });
      });
    }).then(function () {
      var b = qs('.wcd-coupon__apply');
      if (b) b.classList.remove('is-loading');
    });
  }

  function removeCode(code) {
    enqueue(function () {
      return getCart().then(function (cart) {
        return cartPost('cart/update.js', { discount: applicableCodes(cart, code).join(',') });
      }).then(function (json) {
        render(json.sections && json.sections[SECTION]);
        couponMsg('', 'ok');
      });
    });
  }

  /* ---------- checkout (CartPanda) ---------- */
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? m[1] : '';
  }

  function trackingParams() {
    var p = '';
    try {
      if (typeof window.ga === 'function' && window.ga.getAll) {
        var t = window.ga.getAll()[0];
        if (t && t.get('linkerParam')) p += '&' + t.get('linkerParam');
      }
    } catch (e) {}
    try {
      var utm = cookie('_shopify_sa_p');
      if (utm) p += '&' + decodeURIComponent(utm);
      var src = cookie('shop_src_notes');
      if (src) p += '&src=' + decodeURIComponent(src);
    } catch (e) {}
    return p;
  }

  function goToCheckout() { window.location.href = rootUrl + 'checkout'; }

  function checkout(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var inner = qs('.wcd-inner');
    var endpoint = inner ? inner.getAttribute('data-endpoint') : '';
    var shop = inner ? inner.getAttribute('data-shop') : '';
    // Checkout nativo da Shopify (leva automaticamente cupões e a oferta).
    if (!endpoint) { emit('wolf:cart:checkout'); queue.then(goToCheckout, goToCheckout); return; }

    var loader = document.getElementById('cartx-preloader');
    if (loader) { loader.style.zIndex = '2147483647'; loader.style.display = 'block'; }

    emit('wolf:cart:checkout');
    queue.then(getCart).then(function (cart) {
      (cart.items || []).forEach(function (item) { delete item.product_description; });
      return fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify({ shop: shop, host_name: window.location.host, cart_payload: cart })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('checkout');
      return res.json();
    }).then(function (resp) {
      if (!resp || resp.active === false || !resp.checkout_direct_url) throw new Error('checkout');
      var url = resp.checkout_direct_url + trackingParams();
      var clear = typeof resp.remove_cart_item === 'undefined' ? true : !!resp.remove_cart_item;
      if (!clear) { window.location.href = url; return; }
      return fetch(rootUrl + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function () { window.location.href = url; }, function () { window.location.href = url; });
    }).catch(function () {
      // Plano B: checkout nativo da Shopify.
      if (loader) loader.style.display = 'none';
      goToCheckout();
    });
  }

  /* ---------- adicionar ao carrinho a partir das páginas ---------- */
  function showFormError(form, btn, msg) {
    var old = form.querySelector('.wcd-form-error');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'wcd-form-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    var anchor = btn && btn.parentNode ? btn : form.lastElementChild;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(p, anchor.nextSibling);
    else form.appendChild(p);
    setTimeout(function () { if (p.parentNode) p.remove(); }, 7000);
  }

  function addFromForm(form, submitter) {
    var btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('wcd-btn-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var fd;
    try { fd = submitter ? new FormData(form, submitter) : new FormData(form); } catch (e) { fd = new FormData(form); }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fd.append('sections', SECTION);

    enqueue(function () {
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(parseJSON).then(function (json) {
        render(json.sections && json.sections[SECTION]);
        try { document.dispatchEvent(new CustomEvent('modal:close')); } catch (e) {}
        open();
        emit('wolf:cart:added', { id: json.variant_id || json.id, quantity: json.quantity });
      }, function (err) {
        showFormError(form, btn, err.message);
      });
    }).then(function () {
      if (btn) { btn.classList.remove('wcd-btn-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || root.contains(form)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
    if (form.hasAttribute('data-wcd-skip') || window.WolfCartDrawerDisabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromForm(form, e.submitter);
  }, true);

  /* ---------- links para /cart abrem o carrinho lateral ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || root.contains(a) || a.target === '_blank') return;
    var u;
    try { u = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (u.origin !== window.location.origin || u.search || u.hash) return;
    var path = u.pathname.replace(/\/$/, '');
    if (path !== rootUrl + 'cart' && path !== '/cart') return;
    e.preventDefault();
    e.stopPropagation();
    refreshAndOpen();
  }, true);

  /* ---------- eventos dentro do carrinho ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-wcd-close]'))) { e.preventDefault(); close(); return; }

    if ((el = t.closest('[data-wcd-checkout]'))) { e.preventDefault(); checkout(el); return; }

    if ((el = t.closest('[data-wcd-qty]'))) {
      e.preventDefault();
      if (el.disabled) return;
      changeLine(el.getAttribute('data-wcd-line'), el.getAttribute('data-wcd-qty'));
      return;
    }

    if ((el = t.closest('[data-wcd-remove-code]'))) { e.preventDefault(); removeCode(el.getAttribute('data-wcd-remove-code')); return; }

    if ((el = t.closest('[data-wcd-recs-prev], [data-wcd-recs-next]'))) {
      var track = qs('[data-wcd-recs-track]');
      if (!track) return;
      var dir = el.hasAttribute('data-wcd-recs-next') ? 1 : -1;
      var card = qs('[data-wcd-rec]', track);
      var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.85;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
      return;
    }

    if ((el = t.closest('[data-wcd-picker-close]'))) {
      var c = el.closest('[data-wcd-rec]');
      if (c) c.classList.remove('is-picking');
      return;
    }

    if ((el = t.closest('[data-wcd-rec-add]'))) {
      e.preventDefault();
      var recCard = el.closest('[data-wcd-rec]');
      var data = recData(recCard);
      if (!data || !data.v.length) return;
      if (data.si < 0 || data.v.length === 1) {
        var v = pickVariant(data, null);
        if (v) addVariant(v.id); else toast('Produto esgotado', 'error');
        return;
      }
      qsa('[data-wcd-rec].is-picking').forEach(function (x) { if (x !== recCard) x.classList.remove('is-picking'); });
      recCard.classList.toggle('is-picking');
      return;
    }

    if ((el = t.closest('[data-wcd-size]'))) {
      e.preventDefault();
      if (el.disabled) return;
      var sizeCard = el.closest('[data-wcd-rec]');
      var d = recData(sizeCard);
      var chosen = d && pickVariant(d, el.getAttribute('data-wcd-size'));
      if (!chosen) { toast('Tamanho esgotado', 'error'); return; }
      sizeCard.classList.remove('is-picking');
      sizeCard.classList.add('is-adding');
      addVariant(chosen.id);
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.wcd-qty__input');
    if (input) changeLine(input.getAttribute('data-wcd-line'), input.value);
  });

  root.addEventListener('keydown', function (e) {
    var input = e.target.closest && e.target.closest('.wcd-qty__input');
    if (input && e.key === 'Enter') { e.preventDefault(); input.blur(); }
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-wcd-coupon-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('.wcd-coupon__input');
    applyCode(input ? input.value : '');
  });

  root.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-wcd-recs-track')) updateRecsNav();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusables = qsa('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Voltar com o botão "atrás" pode mostrar uma cópia antiga da página.
  window.addEventListener('pageshow', function (e) { if (e.persisted) enqueue(fetchSection); });

  // Abrir automaticamente com ?cart=open (útil em links de emails/anúncios).
  try {
    if (/[?&]cart=open(&|$)/.test(window.location.search)) setTimeout(open, 300);
  } catch (e) {}

  afterRender();

  window.WolfCart = {
    open: open,
    close: close,
    refresh: function () { return enqueue(fetchSection); },
    refreshAndOpen: refreshAndOpen
  };
})();
